import { barclaysThemeTwo } from '../../../components/_ThemeTwo_';

import { defaultDatePicker, defaultModal, IThemeInterface } from './common';

const colorRed20: string = '#faeaea';
const colorRed120: string = '#9d063b';
const colorBrandAlert: string = '#cc3333';
const colorStepBlue: string = '#bfdded';
export const colorAccent: string = '#00395d';
const colorDigitalBlue120: string = '#005fcc';

const colorBrandSecondary: string = '#e5f1f7';
const colorBrandWarning: string = '#dc630a';
const colorBrandPrimary: string = '#0076b6';
const colorBrandLink: string = '#0076b6';
const colorBrandText: string = '#000';

const colorBannerSuccess: string = '#008312';
const colorBannerWarning: string = colorBrandPrimary;
const colorBannerAlert: string = '#cc3333';

const colorButtonDisabled: string = colorStepBlue;

const colorSlate: string = '#f7f5f4';
const colorSlate5: string = '#e5e5e5';
const colorSlate10: string = '#d9d9d9';
const colorSlate20: string = '#b2b2b2';
const colorSlate50: string = '#8d8d8d';
export const colorSlate60: string = '#666666';
const colorSlate70: string = '#333333';
const colorWhite: string = '#fff';
const colorBlack: string = '#000';

const BarclaysTheme: IThemeInterface = {
  name: 'barclays',
  outline: '2px solid #005fcc',
  globalAnchorDecoration: 'none',
  colorBackground: colorWhite,
  colorLineHeight: '2.2rem',
  workflowLinkTextDecoration: 'none',

  colorWhite,
  colorSlate5,
  colorSlate10,
  colorSlate20,
  colorSlate50,
  colorSlate70,
  colorSlate,
  colorBlack,

  actionButton: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorTextActive: colorWhite,
    colorBorder: colorSlate10,
    colorBorderHover: '',
    colorBackgroundActive: '',
  },
  alert: {
    borderWidth: '1px',
    alert: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandAlert,
    },
    success: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    primary: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
    secondary: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBackground: '',
      colorText: colorBrandText,
      colorBorder: colorBrandWarning,
    },
    inactive: {
      colorBackground: colorSlate5,
      colorText: colorBrandText,
      colorBorder: colorSlate5,
    },
    default: {
      colorBackground: 'rgba(1,104,170,0.05)',
      colorText: colorBrandText,
      colorBorder: colorBrandLink,
    },
  },
  banner: {
    alert: {
      colorBorder: colorBannerAlert,
      colorBackground: colorBannerAlert,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    success: {
      colorBorder: colorBannerSuccess,
      colorBackground: colorBannerSuccess,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    primary: {
      colorBorder: colorSlate,
      colorBackground: colorSlate,
      colorText: colorBrandPrimary,
      colorLink: colorBrandPrimary,
    },
    secondary: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorBrandText,
      colorLink: colorBrandText,
    },
    warning: {
      colorBorder: colorBannerWarning,
      colorBackground: colorBannerWarning,
      colorText: colorWhite,
      colorLink: colorWhite,
    },
    inactive: {
      colorBorder: colorSlate5,
      colorBackground: colorSlate5,
      colorText: colorSlate50,
      colorLink: colorSlate50,
    },
    default: {
      colorBorder: colorBrandSecondary,
      colorBackground: colorBrandSecondary,
      colorText: colorSlate,
      colorLink: colorSlate,
    },
    linkTextWeight: '400',
    sectionBackground: colorSlate10,
    paddingBanner: '0.875em 1em',
    fontSizeBannerText: '1.6rem',
    fontWeightBanner: '400',
  },
  bannerSection: {
    colorBackground: colorSlate,
  },
  brand: {
    colorPrimary: colorBrandPrimary,
    colorPrimarySoft: '',
    colorSecondary: colorBrandSecondary,
    colorWarning: colorBrandWarning,
    colorAlert: colorBrandAlert,
  },
  button: {
    primary: {
      boxShadow: 'none',
      padding: '0.639em 1.5em',
      colorBackground: colorBrandPrimary,
      colorBackgroundHover: colorAccent,
      colorBackgroundFocus: colorBrandPrimary,
      colorBorder: colorBrandPrimary,
      colorBorderHover: colorAccent,
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorderDisabled: colorButtonDisabled,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: colorSlate60,
      loadingIconInsideButton: true,
      spinner: {
        size: '21px',
        color: {
          animatedOutline: 'white',
          circleOutline: 'digitalBlue20',
        },
      },
    },
    secondary: {
      boxShadow: 'none',
      padding: '0.639em 1.5em',
      colorBackground: colorWhite,
      colorBackgroundHover: colorBrandSecondary,
      colorBackgroundFocus: colorWhite,
      colorBackgroundDisabled: colorButtonDisabled,
      colorBorder: colorBrandPrimary,
      colorBorderHover: colorAccent,
      colorBorderDisabled: colorButtonDisabled,
      colorBorderFocus: colorDigitalBlue120,
      colorText: colorBrandPrimary,
      colorTextHover: colorBrandPrimary,
      colorTextDisabled: colorSlate60,
      focusBoxShadow: `0 0 0 2px inset ${colorWhite}, 0 0 0 4px inset ${colorBrandPrimary}`,
      loadingIconInsideButton: true,
      spinner: {
        size: '21px',
        color: {
          animatedOutline: 'primary',
          circleOutline: 'digitalBlue10',
        },
      },
    },
    alert: {
      boxShadow: 'none',
      padding: '0.639em 1.5em',
      colorBackground: colorBrandAlert,
      colorBackgroundHover: colorRed120,
      colorBackgroundFocus: colorBrandAlert,
      colorBackgroundDisabled: colorRed20,
      colorBorder: colorBrandAlert,
      colorBorderHover: colorRed120,
      colorBorderFocus: colorBrandPrimary,
      colorBorderDisabled: colorRed20,
      colorText: colorWhite,
      colorTextHover: colorWhite,
      colorTextDisabled: colorBlack,
      loadingIconInsideButton: true,
      spinner: {
        size: '21px',
        color: {
          animatedOutline: 'white',
          circleOutline: 'red30',
        },
      },
    },
    letterSpacing: 'normal',
    focusBoxShadow: `inset 0 0 0 2px ${colorWhite}`,
    fontWeight: '400',
    fontSize: '1.8rem',
    textTransform: 'none',
    borderRadius: '6.25em',
    borderWidth: '2px',
    tinySize: '1.2rem',
    tinyPadding: '0.5em 2em',
    baseButtonMinWidth: '11.5em',
  },
  card: {
    borderRadius: '8px',
    borderWidth: '0',
    colorBorder: 'none',
    colorBackground: colorWhite,
    boxShadow: '1px 2px 7px 1px rgba(0, 0, 0, 0.15)',
  },
  checkbox: {
    colorBorder: colorSlate50,
    colorBackground: colorWhite,
    colorBackgroundChecked: colorBrandPrimary,
    colorBackgroundAlert: colorWhite,
    fontSize: '1.8rem',
  },
  datepicker: {
    ...defaultDatePicker
  },
  header: {
    colorBreadcrumbText: colorBrandText,
    colorHeaderDrawerLinkAboveSmallBP: colorBrandLink,
    colorLink: colorBrandLink,
    colorLinkHover: colorBrandLink,
    colorSubNavLink: colorBrandLink,
    colorSubNavLinkHover: '',
    subNavBreakPoint: 'large',
    summaryWeight: '700',
    breadcrumbIcon: {
      color: colorBrandPrimary,
      size: '24px',
      transform: 'translateY(6px)',
      margin: { right: '1x' },
    },
    headerSubNav: {
      border: { side: 'bottom', color: 'gray400', }
    },
    headerSubNavInnerContainer: {
      padding: {
        base: { horizontal: '2x' },
        medium: { horizontal: '3x' },
      },
    }
  },
  headline: {
    small: {
      size: '1.8rem',
      sizeResponsive: '1.8rem',
      lineHeightResponsive: '1.275',
      lineHeight: '1.275',
      letterSpacing: 'normal',
      weight: '400',
      colorText: colorBlack,
      displayTypeface: 'expert_sans',
    },
    medium: {
      size: '1.8rem',
      sizeResponsive: '2.2rem',
      lineHeight: '1.275',
      lineHeightResponsive: '1.275',
      letterSpacing: 'normal',
      weight: '400',
      colorText: colorBlack,
      displayTypeface: 'expert_sans',
    },
    large: {
      size: '2.2rem',
      sizeResponsive: '3.6rem',
      lineHeight: '1.225',
      lineHeightResponsive: '1.225',
      letterSpacing: 'normal',
      weight: '700',
      colorText: colorBlack,
      displayTypeface: 'expert_sans',
    },
  },
  icon: {
    brandText: {
      colorIcon: colorBrandText,
    },
    brand: {
      colorIcon: colorBrandPrimary,
    },
    link: {
      colorIcon: colorBrandPrimary,
    },
    grey: {
      colorIcon: colorSlate10,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
    },
    tertiary: {
      colorIcon: colorWhite,
    },
    error: {
      colorIcon: colorBrandWarning,
    },
  },
  input: {
    boxShadowHover: 'none',
    boxShadowAlert: 'none',
    colorText: colorBrandPrimary,
    colorBorder: 'none',
    borderWidth: '0',
    colorBackground: colorWhite,
    colorPlaceholder: colorSlate60,
    colorFocus: colorBrandPrimary,
    borderData: { side: 'bottom', color: 'gray500' },
    state: {
      hover: {
        border: { side: 'bottom', color: 'gray500' },
      },
      focus: {
        border: { side: 'bottom', color: 'gray500' },
        outline: { color: 'focus', size: 'double', style: 'solid' },
      },
      error: {
        border: { side: 'bottom', color: 'error' },
        colorText: colorBrandAlert,
      }
    },

    colorTextAreaBorder: colorSlate50,
    colorTextAreaBackground: colorWhite,
    borderRadius: '0',
    padding: '0.5em 0 4px 0',
    selectInputBackgroundSvgFocused: '',
    textAreaPadding: '0.75em',
  },
  label: {
    datapointWeight: '400',
    formLabelColor: colorSlate70,
    formLabelMargin: '0.5em',
    formLabelWeight: '400',
    smallTypeWeight: '400',
    fontWeight: '400',
    size: '1.4rem',
    fontFamily: 'expert_sans_sm',
    spacing: 'normal',
    textTransform: 'none',
    cardLabelSize: '2rem',
    disabledColor: colorSlate50,
  },
  link: {
    colorLink: colorBrandLink,
    colorLinkIcon: colorBrandPrimary,
    colorLinkHover: '',
  },
  modal: {
    ...defaultModal,
    padding: '2em 2.5em',
    colorText: colorBrandText,
    colorHeadlineText: colorBrandText,
    colorDrawerBorder: colorSlate10,
    colorDrawerHover: colorBrandText,
    colorDrawerBackgroundHover: colorSlate10,
    colorBoxShadow: '1px 2px 7px 1px rgba(0,0,0,0.15)',
    colorBackground: 'rgba(0, 0, 0, 0.8)',
    colorClose: colorBrandPrimary,
    borderRadius: '0',
    mobilePadding: '2em',
    mobileColorBackground: 'rgba(0, 0, 0, 0.8)',
    closePadding: '1.25em',
    closeSize: '1em',
    mobileCloseSize: '0.875em',
  },
  notification: {
    success: {
      colorBorder: colorBrandSecondary,
    },
    error: {
      colorBorder: colorBrandWarning,
    },
    info: {
      colorBorder: colorBrandSecondary,
    },
    warning: {
      colorBorder: colorBrandWarning,
    },
    widthBorder: '0.5em',
    spacing: '1em',
    colorHover: colorBrandPrimary,
  },
  pill: {
    alert: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    success: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    primary: {
      colorBackground: colorWhite,
      colorText: colorBrandPrimary,
    },
    secondary: {
      colorBackground: colorWhite,
      colorText: colorBrandSecondary,
    },
    warning: {
      colorBackground: colorWhite,
      colorText: colorBrandWarning,
    },
    inactive: {
      colorBackground: colorWhite,
      colorText: colorSlate50,
    },
    default: {
      colorBackground: colorWhite,
      colorText: colorBrandPrimary,
    },
    letterSpacing: 'normal',
    padding: '0 0.75em',
    borderRadius: '2px',
    textTransform: 'capitalize',
    fontSize: '1.6rem',
  },
  progress: {
    colorBar: '',
    colorCircularBackground: colorSlate10,
    colorBarBackground: 'transparent',
    colorBarBorder: '',
    circularWeight: '700',
    circularSize: '3.6rem',
  },
  progressTracker: {
    colorCompleted: colorBrandPrimary,
    colorOutstanding: colorSlate10,
    colorProgressTrackerBackground: '',
    colorTextOutstanding: colorBrandText,
    colorTextCompleted: colorBrandText,
    colorStepBgCompleted: '',
    colorStepBorderCompleted: '',
    colorStepBgOutstanding: colorSlate5,
    colorStepBorderOutstanding: colorSlate5,
    colorHrOutstanding: colorSlate10,
    colorHrCompleted: '',
    headerContainerPadding: '0.75em 0',
    hrHorizontalOffset: '16px',
    hrVerticalOffset: '-27px',
    hrWidth: '96.4px',
    iconCheckedDone: 'done',
    stepLabelFontWeight: '400',
    stepLabelHorizontalOffset: '0.5em',
    stepNumberFontWeight: '700',
    stepNumberFontSize: '1.6rem',
    stepNumberVerticalOffset: '2px',
    svgCompletedHeight: '17.5px',
    svgCompletedWidth: '17.5px',
    trackerIndicatorWidth: '34px',
    trackerIndicatorHeight: '34px',
    trackerWrapperWidth: '162px',
  },
  radio: {
    boxShadow: '',
    boxShadowHover: '',
    colorBorder: colorSlate50,
    colorBorderHover: colorBrandPrimary,
    colorBorderChecked: colorBrandPrimary,
    colorBackground: colorWhite,
    colorBackgroundHover: colorWhite,
    colorBackgroundChecked: colorBrandPrimary,
    colorText: colorSlate60,
    colorTextHover: colorSlate60,
    colorTextChecked: colorWhite,
    colorTextAlert: colorBrandAlert,
    padding: '0.75em 1.125em',
    borderWidth: '1px',
    fontWeight: '400',
    borderRadius: '8px',
    checked: {
      labelColor: colorWhite,
    },
    focus: {
      outline: { offset: '3px', style: 'auto' }
    },
    disabled: {
      border: { color: 'gray200', size: 'single' },
      labelColor: colorSlate20,
    },
    disabledChecked: {
      colorBackground: colorSlate20,
      border: { color: 'gray400', size: 'single' },
      labelColor: colorWhite,
    },
  },
  radioCard: {
    colorText: colorBrandText,
    colorTextHover: colorBrandText,
    colorBackgroundChecked: colorBrandSecondary,
    borderRadius: '8px',
    boxShadow: '1x',
    border: { size: '0.25px', color: 'gray100' },
    hover: {
      colorBackground: colorBrandSecondary,
    },
    focus: {
      outline: { offset: '5px', style: 'auto' },
      border: { size: '0.25px', color: 'gray100' },
    },
    disabled: {
      colorBackground: colorSlate,
      border: { color: 'gray100', size: 'single' },
      boxShadow: 'none',
    },
  },
  radioInput: {
    borderWidth: '1px',
    borderWidthActive: '1px',
    hasActiveHeightAndWidth: false,
    colorBackground: colorWhite,
    colorInner: colorBrandPrimary,
    colorBorder: colorBrandPrimary,
    colorBorderInactive: colorSlate50,
    colorRadioLabelBackground: 'transparent',
    colorRadioLabelBackgroundActive: 'transparent',
    colorRadioButtonHover: 'transparent',
    sizeRadioButton: '1.5em',
    sizeRadioButtonHover: '1.5em',
    sizeRadioButtonInnerMark: '0.8755em',
    positionRadioButtonInnerMarkTop: '0.5em',
    positionRadioButtonInnerMarkLeft: '0.5em',
    labelTextOffset: '0.75em',
    labelColor: colorSlate60,
    labelColorChecked: colorBrandPrimary,
    hover: {
      border: { color: 'gray500' },
    },
    disabled: {
      border: { color: 'gray400' },
      colorBackground: colorSlate,
      labelColor: colorSlate50,
    },
    disabledChecked: {
      colorInner: colorSlate20,
    },
    error: {
      labelColor: colorBrandAlert,
    },
  },
  spinner: {
    colorBackground: colorBrandSecondary,
    colorSegment: colorBrandPrimary,
  },
  table: {
    alert: {
      colorIcon: colorBrandAlert,
      colorText: colorBrandAlert,
    },
    success: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandSecondary,
    },
    primary: {
      colorIcon: colorBrandPrimary,
      colorText: colorBrandText,
    },
    secondary: {
      colorIcon: colorBrandSecondary,
      colorText: colorBrandText,
    },
    warning: {
      colorIcon: colorBrandWarning,
      colorText: colorBrandText,
    },
    inactive: {
      colorIcon: colorSlate50,
      colorText: colorSlate50,
    },
    default: {
      colorIcon: colorSlate70,
      colorText: colorBrandText,
    },
    filter: {
      colorText: colorBrandText,
      colorTextSelected: colorBrandPrimary,
      colorBackground: '',
      borderRadius: '4px',
    },
    header: {
      colorBackground: colorSlate5,
      colorSubHeaderBackground: '',
      fontWeight: '700',
    },
    colorDetailsButton: colorBrandPrimary,
    colorDivider: colorSlate10,
  },
  taskCard: {
    colorBorder: 'none',
    colorText: colorSlate70,
    colorIcon: 'red',
    colorCtaIcon: colorSlate50,
    colorSubhead: colorSlate70,
    colorInReviewBorder: 'none',
    colorCompleteText: colorSlate60,
    fontWeightHeadline: '400',
    fontWeightSubHead: '400',
    hasIcon: false,
    header: {
      color: {
        incomplete: colorAccent,
      },
      lineHeight: '1.5',
      margin: { bottom: '4px' },
      font: {
        size: 'body'
      },
    },
    statusPill: {
      font: {
        size: 'bodySmall',
      },
    },
    ctaText: {
      textDecoration: 'underline',
      color: colorBrandPrimary,
    },
    card: {
      padding: {
        mobile: '1em',
        small: '1em',
      },
    },
    taskThumb: {
      margin: {
        mobile: '0',
        small: '0',
      },
    },
  },
  text: {
    colorText: colorBrandText,
    colorCaption: colorSlate60,
    formCaptionFontSize: '1.2rem',
    formCaptionFontFamily: 'expert_sans_sm',
  },
  toolTip: {
    paneFontSize: '1.4rem',
    paneFontFamily: 'expert_sans_sm',
    paneBackgroundColor: colorWhite,
    paneBoxShadow: '1px 2px 7px 1px rgba(0,0,0,.15)',
    paneBorderRadius: '8px',
    fontColor: colorBlack,
    border: `1px solid ${colorBrandPrimary}`
  },
  typography: {
    bodyTypeface: 'expert_sans',
    displayTypeface: 'expert_sans',
  },
  upload: {
    colorBackground: colorWhite,
    colorBorder: colorSlate50,
    colorActiveBackground: '',
    colorActiveBorder: colorSlate50,
    colorText: colorBlack,
    borderStyle: 'dashed',
    borderWidth: '2px',
    size: '21em',
    width: '100%',
  },
  verifications: {
    mastHeadlineColor: colorBlack,
  },
  // themeTwo should be removed once themeTwo replaces current theme
  themeTwo: { ...barclaysThemeTwo },
};

export default BarclaysTheme;
